export default {
  // General
  app_name: 'mvplan',
  calculate: 'Calcola decompressione',
  save: 'Salva',
  cancel: 'Annulla',
  add: 'Aggiungi',
  edit: 'Modifica',
  delete: 'Elimina',
  reset: 'Ripristina',
  confirm_reset: 'Ripristinare tutte le impostazioni?',
  confirm_delete: 'Eliminare questo elemento?',

  // Navigation
  nav_plan: 'Piano',
  nav_gases: 'Gas',
  nav_profile: 'Profilo',
  nav_settings: 'Impostazioni',
  nav_day: 'Giornata',

  // Giornata di immersioni
  day_title: 'Giornata di immersioni',
  day_empty: 'Nessuna immersione in questa giornata.',
  day_empty_hint: 'Aggiungi l\'immersione della schermata Piano per iniziare una serie.',
  day_add_current: 'Aggiungi l\'immersione corrente',
  day_add_needs_segments: 'La schermata Piano non contiene alcun segmento: niente da aggiungere.',
  day_ask_surface_interval: 'Intervallo di superficie prima di questa immersione, in minuti:',
  day_invalid_surface_interval: 'Inserisci un intervallo di superficie pari o superiore a 0 min.',
  day_surface_interval: 'Intervallo di superficie',
  day_dive_label_placeholder: 'Nome dell\'immersione (facoltativo)',
  day_calculate: 'Calcola la giornata',
  day_clear: 'Svuota la giornata',
  day_confirm_clear: 'Rimuovere tutte le immersioni di questa giornata?',
  day_remove_dive: 'Rimuovi questa immersione',
  day_confirm_remove: 'Le immersioni successive sono concatenate a questa e dovranno essere ricalcolate.',
  day_dive_not_computed: 'Non ancora calcolata',
  day_dive_stale: 'Calcolata prima di una modifica: questo piano non descrive più la serie.',
  day_dive_refused: 'Immersione rifiutata, controlla le immersioni precedenti della serie.',
  day_dives_refused: '{count} immersione/i non hanno potuto essere pianificate. Le successive sono concatenate a un\'immersione che non esiste.',
  day_summary: 'Totale della giornata',
  day_dives_count: 'Immersioni',
  day_summary_partial: 'I totali coprono {computed} immersione/i calcolata/e su {total}.',
  day_editing_dive: 'Stai modificando l\'immersione {number} della giornata.',
  day_save_into_day: 'Salva nella giornata',
  day_detach: 'Scollega',
  day_dive_number: 'Immersione {number} di {total}',
  day_first_dive: 'Prima immersione della giornata',
  day_nothing_to_export: 'Nessuna immersione di questa giornata è stata calcolata: niente da esportare.',
  day_export_failed: 'Non è stato possibile produrre il documento. Riprova e controlla la console del browser.',

  // Saved days
  saved_days_title: 'Giornate salvate',
  saved_days_save: 'Salva la giornata',
  saved_days_saved: 'Giornata salvata',
  saved_days_save_failed: 'Non è stato possibile salvare questa giornata: non contiene alcuna immersione, oppure la memoria è piena.',
  saved_days_name_placeholder: 'es. Port-Cros, sabato',
  saved_days_empty: 'Nessuna giornata salvata.',
  saved_days_empty_hint: 'Componi una giornata di immersioni, poi salvala per ritrovarla qui.',
  saved_days_confirm_delete: 'Eliminare questa giornata?',
  saved_days_import_error: 'Questo file non è una giornata di immersioni esportata da mvplan.',

  // Settings
  settings_algorithm: 'Algoritmo',
  settings_gf: 'Fattori di gradiente',
  settings_gf_low: 'GF Basso',
  settings_gf_high: 'GF Alto',
  settings_rates: 'Velocità e Tappe',
  settings_descent: 'Discesa',
  settings_ascent: 'Risalita',
  settings_deco_ascent: 'Tra le tappe',
  settings_last_stop_ascent: 'Risalita finale',
  settings_last_stop: 'Ultima tappa',
  settings_safety_stop: 'Sosta di sicurezza senza deco (min, 0 = nessuna)',
  settings_rmv: 'RMV',
  settings_rmv_bottom: 'Fondo',
  settings_rmv_deco: 'Deco / Bailout',
  settings_ccr: 'Modalità CCR',
  settings_setpoint_mode: 'Modalità Setpoint',
  settings_setpoint_fixed: 'Fisso',
  settings_setpoint_dynamic: 'Dinamico',
  settings_ppo2: 'Limiti ppO2',
  settings_ppo2_working: 'Lavoro',
  settings_ppo2_deco: 'Deco',
  settings_display: 'Visualizzazione',
  settings_units: 'Unità',
  settings_units_metric: 'Metriche (m, bar)',
  settings_units_imperial: 'Imperiali (ft, psi)',
  settings_theme: 'Tema',
  settings_theme_dark: 'Scuro',
  settings_theme_light: 'Chiaro',
  settings_language: 'Lingua',
  settings_divers: 'Subacquei',
  settings_divers_hint: 'Nomi stampati sul PDF (separati da virgole)',
  settings_dive_site: 'Sito di immersione',
  settings_dive_site_placeholder: 'es. Blue Hole, Dahab',
  settings_bailout: 'Bailout',
  settings_bail_delay: 'Ritardo bailout (min)',
  settings_bail_delay_hint: 'Tempo sul fondo prima della risalita in bailout',
  settings_rmv_stress: 'RMV Stress',
  settings_stress_until: 'Stress fino a',
  settings_stress_first_stop: 'Prima tappa',
  settings_stress_gas_switch: 'Cambio gas',
  settings_stress_surface: 'Superficie',
  settings_time_and_gas: 'Tempi e cambi di gas',
  settings_descent_included: 'Discesa inclusa',
  settings_descent_included_hint: 'Il tempo di discesa è incluso nella durata del segmento',
  settings_gas_switch_duration: 'Durata del cambio gas',
  settings_gas_switch_at_stop: 'Cambiare gas solo alla tappa deco',
  settings_gas_switch_at_stop_hint: 'Se disattivato, il cambio avviene appena la MOD lo consente (più ottimale)',
  settings_gf_presets: 'Preset GF',
  settings_gf_presets_hint: 'Accesso rapido nella vista Piano',
  settings_gf_add_preset: 'Aggiungi preset',
  settings_gf_preset_name: 'Nome',
  settings_gf_custom: 'Personalizzato',
  settings_environment: 'Ambiente',
  settings_gas_temp: 'Temp. gas',
  settings_water_type: 'Tipo di acqua',
  settings_water_salt: 'Acqua salata',
  settings_water_fresh: 'Acqua dolce',
  settings_water_brackish: 'Acqua salmastra',
  settings_water_red_sea: 'Mar Rosso',
  settings_water_custom: 'Densità personalizzata',
  settings_water_density: 'Densità dell\'acqua',
  settings_water_density_hint: 'La densità dell\'acqua cambia la pressione realmente subita a una data profondità e quindi la durata delle tappe. Valori di riferimento: 10000 in acqua dolce, 10150 in acqua salmastra, 10300 in mare, 10400 nel Mar Rosso (10300 corrisponde a 1.03 kg/l). Valori accettati: da {min} a {max}.',
  settings_altitude: 'Altitudine',
  settings_environment_hint: 'Temp. gas = temperatura polmonare per il calcolo della densità (~35°C). Anche l\'altitudine e il tipo di acqua modificano il calcolo della decompressione.',
  settings_alerts: 'Avvisi di sicurezza',
  settings_alerts_hint: 'Disattiva avvisi per subacquei esperti',
  settings_alerts_narcosis: 'Avvisi narcosi (END)',
  settings_alerts_density: 'Avvisi densità (CO2)',
  settings_alerts_show_density: 'Mostrare sempre la densità del gas',
  settings_ccr_flush: 'Lavaggi del circuito (CCR)',
  settings_ccr_flush_hint: 'Aggiunge un editor di lavaggi alla schermata del piano per le immersioni con rebreather.',
  settings_ccr_flush_duration: 'Durata di lavaggio predefinita (min)',
  settings_ccr_o2_flush: 'Fine immersione al 100% di ossigeno',
  settings_ccr_o2_flush_hint: 'Alla profondità impostata, il circuito passa a ossigeno puro e vi resta fino alla superficie.',
  settings_ccr_o2_flush_depth: 'Profondità (m)',
  settings_ccr_o2_flush_time: 'Durata del lavaggio (min)',
  settings_ccr_o2_flush_invalid: 'Profondità o durata inutilizzabile.',
  settings_alerts_icd: 'Avvisi ICD (orecchio interno)',
  settings_pdf: 'Esportazione PDF',
  settings_pdf_include_profile: 'Includi profilo di immersione',
  settings_pdf_include_profile_hint: 'Disattiva per stare su una sola pagina A4',
  settings_school_mode: 'Modalità scuola',
  settings_school_mode_hint: 'Confronta i preset GF sul grafico del profilo',
  settings_chart_scale: 'Scala del grafico',
  settings_school_presets: 'Preset da confrontare',
  profile_school_compare: 'Confronto GF',
  profile_school_tts: 'TTS',
  profile_school_stops: 'Tappe',

  // Gases
  gases_title: 'Miscele gas',
  gases_bailout: 'Gas di emergenza',
  gases_diluents: 'Diluenti',
  gases_name: 'Nome',
  gases_mod: 'MOD',
  gases_end: 'END',
  gases_ppo2_max: 'ppO2 max',
  gases_use_bailout: 'Usa come bailout',
  gases_tank_config: 'Configurazione bombola',
  gases_volume: 'Volume (L)',
  gases_pressure: 'Pressione (bar)',
  gases_capacity: 'Capacità',

  // Plan
  plan_segments: 'Segmenti immersione',
  plan_depth: 'Profondità',
  plan_time: 'Tempo',
  plan_runtime: 'Runtime',
  plan_gas: 'Gas',
  plan_setpoint: 'SP',
  plan_no_segments: 'Nessun segmento. Aggiungine uno.',
  plan_config: 'Configurazione',
  plan_ccr: 'Piano CCR',
  plan_bailout: 'Bailout (Caso peggiore)',
  plan_deco: 'Piano decompressione',
  plan_no_deco: 'Decompressione non richiesta',
  plan_stops_summary: 'Riepilogo tappe',
  duration_hours_minutes: '{h} h {m}',
  duration_hours: '{h} h',
  duration_minutes: '{m} min',
  plan_desat_sea_level: 'Restando al livello del mare, sarai completamente desaturato {time} dopo l\'uscita dall\'acqua.',
  plan_desat_altitude: 'Restando a {altitude} m di altitudine, sarai completamente desaturato {time} dopo l\'uscita dall\'acqua.',
  plan_desat_over: 'La desaturazione completa richiede più di {time} dopo l\'uscita dall\'acqua.',
  plan_no_fly: 'Volo (DAN)',
  plan_no_fly_minimum: '> {time}',
  plan_no_fly_dan_rule: 'Attesa prima di volare, raccomandazioni del consenso DAN: un intervallo di superficie di almeno {noStop} per un\'immersione singola senza decompressione; un intervallo di superficie di almeno {multiDay} per immersioni ripetitive su più giorni; sostanzialmente più di {longer} dopo un\'immersione con decompressione obbligatoria, o con miscele heliox e trimix. Non è un calcolo di desaturazione.',
  plan_no_fly_dan_case_no_stop: 'Questa immersione rientra nel primo caso: un\'immersione singola senza tappe.',
  plan_no_fly_dan_case_repetitive: 'Questa immersione rientra nel secondo caso: immersioni ripetitive.',
  plan_no_fly_dan_case_deco: 'Questa immersione rientra nel terzo caso: decompressione obbligatoria. L\'attesa mostrata è un minimo da superare, non un valore raccomandato.',
  plan_no_fly_dan_case_helium: 'Questa immersione rientra nel terzo caso: miscela con elio. L\'attesa mostrata è un minimo da superare, non un valore raccomandato.',
  plan_no_fly_dan_source: 'Fonte: DAN, Guidelines for Flying After Diving, consenso del Flying After Recreational Diving Workshop (2002). Queste prove sono state condotte in camera secca con volontari a riposo: possono essere necessarie attese più lunghe per subacquei immersi e sotto sforzo.',
  plan_tts: 'TTS',
  plan_cns: 'CNS',
  plan_otu: 'OTU',
  plan_cns_series: 'CNS (giornata)',
  plan_otu_series: 'OTU (giornata)',
  plan_gas_requirements: 'Fabbisogno gas bailout',
  plan_gas_consumption: 'Consumo gas',
  plan_liters: 'Litri',
  plan_type: 'Tipo',
  plan_ppo2: 'ppO2',
  plan_density: 'Densità',
  plan_tissue: 'Tessuto',
  plan_flush: 'Lavaggi del circuito',
  plan_flush_hint: 'Lavaggi voluti del circuito durante la risalita, dal più profondo al più basso. Durante un lavaggio il circuito respira la miscela scelta alla pressione ambiente, non il setpoint.',
  plan_flush_add: 'Aggiungi un lavaggio',
  plan_flush_none: 'Nessun lavaggio previsto',
  plan_flush_depth: 'Profondità',
  plan_flush_gas: 'Lavare con',
  plan_flush_time: 'Durata',
  plan_flush_keep: 'Mantenere questa miscela',
  plan_flush_keep_hint: 'Il circuito resta sulla miscela del lavaggio fino alla superficie, cioè lo spurgo deliberato dell\'elio prima della decompressione. Se non selezionato, torna al diluente in servizio: un lavaggio è un gesto, non un cambio di gas.',
  plan_flush_remove: 'Rimuovi',
  plan_flush_figures: '{gas} a {depth} m: ppO2 {ppO2} bar, END {end} m, densità {density} g/L',
  plan_o2_flush_row: 'Fine a ossigeno: {time} min di lavaggio a {depth} m, il circuito resta a ossigeno fino alla superficie.',
  plan_o2_flush_source: 'Impostato nelle impostazioni CCR, non modificabile qui.',
  plan_o2_flush_skipped_setting: 'La fine a ossigeno delle impostazioni ha una profondità o una durata inutilizzabile e non viene applicata.',
  plan_o2_flush_skipped_clash: 'La fine a ossigeno delle impostazioni si fa da parte a {depth} m: lì è già previsto un tuo lavaggio.',
  plan_o2_flush_skipped_too_deep: 'La fine a ossigeno prevista a {depth} m non viene applicata: questa immersione non scende mai sotto {maxDepth} m.',
  plan_flush_helper: 'Calcola',
  plan_flush_helper_title: 'Profondità del lavaggio',
  plan_flush_helper_hint: 'Indichi che cosa cerca e viene calcolata la profondità corrispondente, per la miscela di questo lavaggio e per l\'acqua e la quota del sito.',
  plan_flush_helper_mix: 'Miscela del lavaggio',
  plan_flush_helper_target: 'Obiettivo',
  plan_flush_target_ppo2: 'ppO2 (bar)',
  plan_flush_target_end: 'END (m)',
  plan_flush_helper_result: '{depth} m ({exact} m esatti)',
  plan_flush_helper_rounding: 'Arrotondato al metro meno profondo, quindi i valori qui sotto sono quelli del piano.',
  plan_flush_helper_apply: 'Usa questa profondità',
  plan_flush_helper_unreachable: 'Questa miscela non raggiunge quel valore a nessuna profondità.',
  plan_flush_helper_deeper: 'Più profondo del fondo a {maxDepth} m: un lavaggio si fa in risalita.',
  plan_flush_helper_no_nitrogen: 'Questa miscela non contiene azoto: il suo END è nullo a ogni profondità.',
  plan_flush_helper_band: 'Fuori dalla sua banda di lavoro {min} - {max} bar.',
  plan_descent: 'Discesa',
  plan_ascent: 'Risalita',
  plan_bottom: 'Fondo',
  plan_stop: 'Tappa',
  plan_total_runtime: 'Runtime totale',
  plan_deco_time: 'Tempo deco',
  plan_max_depth: 'Prof. max',
  plan_bottom_time: 'Tempo fondo',
  plan_based_on_rmv: 'Basato su RMV',
  plan_insufficient_gas: 'Una o più bombole non hanno capacità sufficiente per questo bailout!',
  plan_bars_needed: 'bar necessari',

  // Profile
  profile_title: 'Profilo immersione',
  profile_saturation: 'Saturazione tessuti',
  profile_tap_details: 'Tocca per dettagli',
  profile_ceiling: 'Tetto',
  profile_surface: 'Superficie',
  profile_residual: 'N2 residuo',
  profile_calculate_hint: 'Calcola un piano per vedere il profilo',
  profile_fullscreen: 'Schermo intero',


  // Units
  unit_meters: 'm',
  unit_feet: 'ft',
  unit_minutes: 'min',
  unit_bar: 'bar',
  unit_psi: 'psi',
  unit_lpm: 'L/min',

  // Additional Plan
  plan_add_segment: 'Aggiungi segmento',
  plan_edit_segment: 'Modifica segmento',
  plan_diluent: 'Diluente',
  plan_dynamic_setpoint_info: 'Modalità dinamica attiva',
  plan_override_setpoint: 'Forzare un setpoint fisso (opzionale)',
  plan_setpoint_auto: 'Auto',
  plan_mode: 'Modalità',
  plan_algorithm: 'Algoritmo',
  plan_export_pdf: 'Esporta PDF',
  plan_save_html: 'Salva HTML',
  plan_calculate_first: 'Calcola prima un piano',
  plan_segment_for: '{depth}m per {time} min',
  plan_gas_at_sp: '{gas} @ SP{sp}',
  plan_tank: 'Bombola',
  plan_needed: 'Necessario',
  plan_status: 'Stato',
  plan_insufficient: 'INSUFFICIENTE',
  plan_gas_tight: 'AL LIMITE',
  plan_ok: 'OK',
  plan_need_more: 'Mancano {liters}L ({bars} bar)',
  plan_left: '{liters}L rimasti ({bars} bar)',
  plan_need_more_liters: 'Mancano {liters}L',
  plan_left_liters: '{liters}L rimanenti',
  plan_gas_unused: 'NON RESPIRATO',
  plan_gas_unused_detail: '{liters}L trasportati, mai aperti da questo piano',
  plan_gas_backup: 'Riserva: {names}',

  // Gases additional
  gases_name_auto: 'Nome (auto se vuoto)',
  gases_auto_label: 'Etichetta automatica',
  gases_n2_calc: 'N2 % (calcolato)',
  gases_end_at_mod: 'END @ MOD',
  gases_confirm_delete: 'Eliminare questo gas?',
  gases_confirm_delete_diluent: 'Eliminare questo diluente?',
  gases_only_diluent: 'Impossibile eliminare l\'unico diluente',
  gases_form_invalid: 'Valori inutilizzabili: O2 sopra 0 % e al massimo 100 %, He da 0 % a meno di 100 %, somma al massimo 100 %; limite di ppO2, volume e pressione della bombola sopra 0.',
  plan_segment_invalid: 'Inserire una profondità da 1 a 200 m, una durata da 1 a 999 min e un setpoint da 0,7 a 1,6 bar.',

  // Segment types
  segment_bail: 'BAIL',
  segment_desc: 'Disc',
  segment_asc: 'Ris',
  segment_bottom: 'Fondo',
  segment_stop: 'Tappa',
  segment_gas_change: 'Camb. gas',
  segment_diluent_change: 'Camb. dil.',
  segment_flush: 'Lavaggio',
  segment_safety_stop: 'Sicur.',

  // Saved Plans
  nav_saved: 'Salvati',
  saved_plans_title: 'Piani salvati',
  saved_plans_save: 'Salva piano',
  saved_plans_saved: 'Piano salvato!',
  saved_plans_empty: 'Nessun piano salvato',
  saved_plans_empty_hint: 'Calcola un piano e salvalo per dopo',
  saved_plans_load: 'Carica',
  saved_plans_rename: 'Rinomina',
  saved_plans_duplicate: 'Duplica',
  saved_plans_export: 'Esporta',
  saved_plans_confirm_delete: 'Eliminare questo piano?',
  saved_plans_import: 'Importa',
  saved_plans_import_error: 'Importazione fallita',
  saved_plans_name_label: 'Nome piano',
  saved_plans_name_placeholder: 'Inserisci nome piano',
  plan_share: 'Condividi',
  feature_next_version: 'Disponibile nella prossima versione',

  // Dive environment carried by a plan: named in the exports and in the saved
  // plan list, and flagged when the plan on screen was computed for another one
  plan_environment_changed: 'Questo piano è stato calcolato per un altro tipo di acqua o un\'altra altitudine. Ricalcolarlo prima di immergersi.',
  // Any other input the calculation reads (gradient factors, rates, ppO2
  // limits, gases, rebreather...) changed after the plan was computed
  plan_inputs_changed: 'Questo piano è stato calcolato con altri parametri di immersione. Ricalcolarlo prima di immergersi.',
  export_environment: 'Ambiente',
  saved_plan_environment: 'Ambiente',

  // PDF Export
  pdf_title: 'Piano immersione - mvplan',
  pdf_exporting: 'Generazione PDF...',
  pdf_generated: 'Generato il',
  pdf_mode_oc: 'Circuito aperto',
  pdf_footer_generated: 'Generato da mvplan - Pianificatore immersioni tecniche',
  pdf_footer_verify: 'Verificare sempre il piano e portare tabelle di riserva',

  // PDF format choice
  pdf_choose_format: 'Formato del PDF',
  pdf_choose_format_hint: 'Scegli quale documento esportare',
  pdf_format_complete: 'Completo',
  pdf_format_complete_hint: 'Rapporto dettagliato su più pagine (tabelle, profilo, gas)',
  pdf_format_condensed: 'Compatto (1 pagina)',
  pdf_format_condensed_hint: 'Scheda di pianificazione stampabile su una sola pagina',

  // PDF condensed form
  pdf_form_title: 'Pianificazione immersione',
  pdf_form_date: 'Data',
  pdf_form_team: 'Gruppo n.',
  pdf_form_diver: 'Subacqueo',
  pdf_form_lastname: 'Nome, Cognome',
  pdf_form_machine: 'Apparato',
  pdf_form_gf: 'Grad. Fac.',
  pdf_form_runtime_title: 'Run Time',
  pdf_form_planned_depth: 'Profondità prevista',
  pdf_form_planned_bottom: 'Tempo di fondo previsto',
  pdf_form_palier: 'Prof. sosta',
  pdf_form_descent: 'Discesa',
  pdf_form_bottom: 'Fondo',
  pdf_form_duration: 'Durata',
  pdf_form_cumul: 'Cumul.',
  pdf_form_mutualized: 'Condiviso',
  pdf_form_vol_liters: '% / Vol. in litri',
  pdf_form_col_pct: '%',
  pdf_form_col_vol: 'Vol.',
  pdf_form_col_press: 'Pres.',
  pdf_form_col_liters: 'Lit.',
  pdf_form_yes: 'sì',
  pdf_form_no: 'no',
  pdf_form_gas_switch_legend: 'cambio gas',
  pdf_form_gas_verdict_legend: "Casella Lit. del subacqueo 1: verde = OK, arancione = al limite, rosso = insufficiente per la risalita in bailout, grigio = non respirato. Cifre nella colonna di destra.",
  pdf_form_dtr: 'TTS',

  // Safety Alerts
  alerts_summary_title: 'Punti di attenzione di questo piano',
  alert_hypoxia: 'ppO2 {value} bar sotto il minimo di 0.16 bar: questa miscela non è respirabile a questa profondità. Prevedere un gas più ricco di ossigeno.',
  alert_hyperoxia: 'ppO2 {value} bar oltre il massimo di 1.6 bar. Ridurre la frazione di ossigeno o usare questo gas a profondità minore.',
  alert_end_critical: 'END {value}m oltre il limite di 40m. Aggiungere elio alla miscela di fondo per ridurre la narcosi.',
  alert_end_high: 'END {value}m oltre i 30m raccomandati. Una miscela più ricca di elio riduce la narcosi.',
  alert_density_critical: 'Densità del gas {value} g/L oltre i 6.2 g/L raccomandati: la respirazione può diventare difficile a questa profondità. Aggiungere elio alla miscela di fondo.',
  alert_density_high: 'Densità del gas {value} g/L oltre i 5.2 g/L consigliati in rebreather. Limitare gli sforzi o arricchire il diluente di elio.',
  alert_narcosis_increase: 'La ppN2 passa da {ccrValue} a {value} bar al passaggio in bailout: narcosi più marcata che con il rebreather. Un bailout più ricco di elio attenua la transizione.',
  alert_end_increase: 'La END passa da {ccrValue}m a {value}m al passaggio in bailout. Un bailout più ricco di elio riduce questo divario.',
  alert_icd_risk: 'L\'elio scende da {prevValue}% a {value}% a questo cambio di gas. Una transizione più graduale (miscela intermedia) evita la controdiffusione isobarica.',
  alert_ceiling_violation: 'Questo profilo risale a {depth}m mentre il tetto deco è a {ceiling}m. Restare sotto il tetto e prolungare la tappa prima di risalire.',
  alert_stop_time_truncated: 'Tappa a {depth}m limitata a {time} min: raggiunto il limite interno di calcolo senza liberare il tetto. Questo piano è incompleto, non seguirlo - ridurre il tempo di fondo, aggiungere un gas deco o alzare il GF alto.',
  alert_runtime_limit: 'Calcolo interrotto al limite interno di runtime di {runtime} min: questo piano è incompleto, non seguirlo - accorciare l\'immersione o aggiungere un gas deco più ricco.',
  alert_entry_ceiling: 'Soffitto a {ceiling}m all\'inizio di questa immersione, con i fattori di gradiente impostati qui: l\'intervallo di superficie di {interval} min non libera l\'immersione precedente, il subacqueo deve già una tappa prima di rientrare in acqua. Questo piano la recupera in risalita: allunga l\'intervallo prima di immergerti.',
  alert_residual_state_unloaded: 'Stato tissutale residuo senza alcun carico: dichiara di seguire un\'immersione, eppure nessun compartimento è sopra il proprio livello di riposo. Questo piano è quindi più corto della stessa immersione calcolata su tessuti puliti: non immergerti con questo piano, ricalcola l\'immersione precedente.',
  alert_default_gas_fallback: 'Nessuna miscela attiva: questo piano è stato calcolato ad aria per impostazione predefinita. Non corrisponde ai gas configurati - attivare almeno una miscela nella vista Gas e ricalcolare prima di immergersi.',
  alert_gas_above_mod: 'Nessun gas trasportato raggiunge {depth}m sotto il limite di ppO2 di {limit} bar che vi si applica: questo piano vi fa respirare {gas}, oltre la sua MOD di {mod}m a quel limite, a una ppO2 di {ppO2} bar. È la miscela più povera del vostro elenco, scelta per impostazione predefinita e non da voi - portate una miscela adatta a questa profondità, oppure alzate il limite, prima di immergervi.',
  alert_gas_switch_on_empty: 'La bombola di {gas} si svuota a {depth}m: il cambio gas mostrato lì non è una commutazione di decompressione che hai previsto, è il piano che passa a ciò che resta. Porta più di questa miscela, oppure prevedi un tuo cambio al di sopra di questa profondità, prima di immergerti.',
  alert_gas_exhausted: 'Tutte le bombole utilizzabili a {depth}m sono vuote: da lì in poi questo piano prescrive gas che non porti più. Aggiungi capacità, o una miscela che raggiunga quella profondità, prima di immergerti.',
  alert_gas_insufficient: 'Le bombole di {gas} contengono {capacity} L e questo piano ne respira {liters} L: mancano {missing} L. Portane di più, o pianifica un\'immersione più breve, prima di immergerti.',
  alert_flush_not_reached: 'Il lavaggio del circuito previsto a {depth}m non avviene mai: la risalita finale parte da {ascentStart}m, più in alto. Sposta il lavaggio più in alto, o rendilo l\'ultimo livello dell\'immersione.',
  alert_flush_ppo2: 'Il lavaggio a {depth}m con {gas} porta il circuito a {ppO2} bar di ossigeno, fuori dalla tua banda di lavoro {min} - {max} bar. Durante un lavaggio il setpoint non tiene: nel circuito c\'è quello che la miscela fornisce a quella profondità.',
  alert_o2_flush_too_deep: 'La fine a ossigeno prevista a {depth}m non avviene mai: questa immersione non scende mai sotto {maxDepth}m, nessuna risalita passa da quella profondità.',

  // Plan validation errors
  plan_error_title: 'Impossibile calcolare il piano',
  plan_error_no_segments: 'Nessun segmento di immersione: aggiungere almeno un segmento con profondità e durata.',
  plan_error_invalid_depth: 'Profondità non valida: inserire una profondità maggiore o uguale a 0 m per ogni segmento (0 m corrisponde a un intervallo di superficie).',
  plan_error_invalid_time: 'Durata non valida: inserire una durata maggiore o uguale a 0 min per ogni segmento.',
  plan_error_invalid_gf: 'Fattori di gradiente non validi: il GF basso deve essere minore o uguale al GF alto, entrambi maggiori di 0% e al massimo 100%.',
  plan_error_invalid_gas: 'Miscela gas non valida: la frazione di O2 deve essere maggiore di 0% e al massimo 100%, la frazione di He compresa tra 0% e meno di 100%, e la loro somma non deve superare il 100%.',
  plan_error_no_diluent: 'Nessun diluente valido: scegliere un diluente per l\'immersione con rebreather nella vista Gas.',
  plan_error_invalid_setpoint: 'Setpoint non valido: inserire un setpoint ppO2 compreso tra 0.4 e 1.6 bar, estremi inclusi.',
  plan_error_no_bailout_gas: 'Nessun gas di emergenza attivo: attivare almeno un gas bailout nella vista Gas per calcolare il bailout.',
  plan_error_invalid_tissue_state: 'Stato tissutale residuo inutilizzabile: non è stato possibile leggere l\'immersione precedente della serie. Ricalcola l\'immersione precedente prima di pianificare questa.',
  plan_error_invalid_surface_interval: 'Intervallo di superficie non valido: inserisci una durata pari o superiore a 0 min tra l\'immersione precedente e questa.',
  plan_error_invalid_flush: 'Lavaggio del circuito non valido: dai a ogni lavaggio una profondità sopra il fondo, una durata superiore a 0 min e un solo lavaggio per profondità.',
  plan_error_time_shorter_than_descent: 'Durata del segmento inferiore alla sua discesa: raggiungere {depth} m richiede {descentTime} min alla velocità di discesa impostata, e il segmento dura solo {time} min. Il tempo di discesa è incluso nella durata del segmento (vedi impostazioni): inserire una durata maggiore o disattivare questa opzione.',
  plan_error_segment_gas_unavailable: 'Il segmento {index} ({depth} m) è pianificato su {gas}, che è disattivato o non esiste più. Attiva quel gas nella vista Gas o scegline un altro per il segmento.',
  plan_error_no_bailout_point: 'Il piano rebreather non porta alcun punto di bailout: non è stato prodotto da questa versione del pianificatore. Ricalcola il piano rebreather prima del suo bailout.',
  plan_error_invalid_config: 'Impostazione del pianificatore non valida: una velocità di risalita o discesa, una profondità di tappa o un limite di ppO2 è fuori intervallo. Controllare le impostazioni del pianificatore prima di calcolare.',

  // Dive Info
  plan_notes: 'Note',
  plan_notes_placeholder: 'Aggiungi note per il piano stampato (promemoria, istruzioni, ecc.)',
  plan_divers_placeholder: 'Subacquei per questa immersione',

  // App Store Links
  app_available_on: 'Disponibile su:',
  app_get_ios: 'Scarica su App Store',
  app_get_android: 'Scarica su Google Play',

  // Tissue compartment descriptions
  tissue_desc_1: 'Sangue, midollo spinale',
  tissue_desc_2: 'Sangue, cervello',
  tissue_desc_3: 'Cervello, tessuto nervoso',
  tissue_desc_4: 'Muscoli ben irrorati',
  tissue_desc_5: 'Pelle, visceri',
  tissue_desc_6: 'Muscoli, organi',
  tissue_desc_7: 'Muscoli',
  tissue_desc_8: 'Muscoli, legamenti',
  tissue_desc_9: 'Tendini, tessuto connettivo',
  tissue_desc_10: 'Cartilagini',
  tissue_desc_11: 'Cartilagini, ossa',
  tissue_desc_12: 'Ossa, articolazioni',
  tissue_desc_13: 'Ossa, grasso',
  tissue_desc_14: 'Tessuto adiposo',
  tissue_desc_15: 'Grasso, midollo osseo',
  tissue_desc_16: 'Grasso, midollo osseo',
  tissue_halftime: 'Tempo di dimezzamento',
  tissue_speed_fast: 'tessuto rapido',
  tissue_speed_medium: 'tessuto medio',
  tissue_speed_slow: 'tessuto lento',
  tissue_leading: 'Compartimento direttore',
  tissue_leading_detail: '{tissue} (C{num}) impone il tetto a {ceiling}m - caricato al {gf}% (GF {gfLow}/{gfHigh}, limite qui: {gfLimit}%)',
  tissue_leading_no_ceiling: '{tissue} (C{num}) è il più carico - caricato al {gf}% (GF {gfLow}/{gfHigh}, limite qui: {gfLimit}%)',
  tissue_detail_title: 'Dettaglio compartimento',
  tissue_detail_coefficients: 'Coefficienti {algo}: a={a} (tolleranza alla sovrasaturazione), b={b} (sensibilità alla profondità). Costanti empiriche di Bühlmann - i tessuti rapidi (C1) tollerano di più (a=1.17), i tessuti lenti (C16) di meno (a=0.23).',
  tissue_detail_saturation: 'Saturazione',
  tissue_detail_gf_actual: 'GF reale',
  tissue_detail_no_supersaturation: 'Nessuna sovrasaturazione',
  tissue_detail_undersaturated: 'Questo compartimento non è sovrasaturo: la pressione tissutale è inferiore alla pressione ambiente. Il concetto di GF si applica solo quando il tessuto è sovrasaturo (in risalita o alla tappa).',
  tissue_detail_explanation: '{saturation}% di saturazione non significa {saturation}% di GF. Il GF ({gfActual}%) misura la frazione di margine utilizzata tra la pressione ambiente e la M-value. Con GF High {gfHigh}%, una saturazione di {saturation}% è attesa.',
  tissue_detail_explanation_gf_low: 'GF Low ({gfLow}%) determina la profondità della prima tappa di decompressione. Qui l\'algoritmo consente al subacqueo di fermarsi per la prima volta in risalita: il compartimento direttore utilizza {gfUsed}% del suo margine tra pressione ambiente e M-value. Più basso è il GF Low, più profonde iniziano le tappe.',
  tissue_detail_explanation_interpolated: 'Tra la prima tappa e la superficie, il GF è interpolato linearmente da GF Low ({gfLow}%) a GF High ({gfHigh}%). A questa profondità, il limite applicato è {gfUsed}%. Il GF reale di questo compartimento è {gfActual}%.',

  // Disclaimer
  disclaimer_title: 'Avvertenza',
  disclaimer_text: 'Questo software è solo un aiuto alla pianificazione delle immersioni. Non sostituisce la formazione, l\'esperienza o il giudizio del subacqueo. Gli autori declinano ogni responsabilità per incidenti. Verificare sempre il piano con altri strumenti e portare tabelle di riserva.',
  disclaimer_short: 'Solo aiuto alla pianificazione - non sostituisce formazione o giudizio - nessuna responsabilità',

  // Sostenere il progetto
  support_nav: 'Sostieni il progetto',
  support_nav_website: 'Il progetto',
  support_title: 'Sostenere MV-Plan',
  support_intro: 'MV-Plan è software libero. Nessuna pubblicità, nessun account da creare, nessuna raccolta di dati, e tutte le funzioni sono a disposizione di tutti. Non cambierà.',
  support_costs_title: 'Quanto costa il progetto',
  support_cost_apple: 'Account sviluppatore Apple: 99 USD all\'anno, dovuti anche se l\'applicazione è gratuita.',
  support_cost_google: 'Account sviluppatore Google Play: 25 USD una tantum.',
  support_cost_domain: 'Nome a dominio e hosting del sito mvplan.org.',
  support_cost_time: 'Il tempo dedicato a sviluppare, provare e documentare il pianificatore.',
  support_amount: 'Bastano pochi euro. La maggior parte dei contributi va da 3 a 10 euro, ed è già molto.',
  support_nothing_unlocked: 'Contribuire non sblocca nulla: nessuna versione a pagamento, nessuna opzione nascosta, nessun nome in vetrina. L\'applicazione resta la stessa per tutti.',
  support_thanks: 'Grazie a chi ha già contribuito.',
  support_button: 'Contribuire',
  support_link_label: 'Indirizzo della pagina',
  support_copy: 'Copia il link',
  support_copied: 'Link copiato',
  support_copy_failed: 'Copia non riuscita, seleziona l\'indirizzo a mano',
  support_open_hint: 'Se il pulsante non apre nulla, copia l\'indirizzo qui sopra nel browser.',
  support_website_title: 'Il progetto',
  support_website_intro: 'MV-Plan è software libero, sviluppato nel tempo libero del suo autore. Il sito del progetto raccoglie la documentazione, le note di versione e i contatti.',
  support_website_button: 'Apri il sito del progetto'
}
